import { Input, Button, Col, Row } from "reactstrap";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage } from "react-intl";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

export default function MoveUser() {
  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col xs="3" className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="MoveUser" />
          </h5>
        </Col>
      </Row>
      <Row>
        <Col xs="3" className="mb-2">
          <Input id="user-move-email" placeholder="användarens email" />
        </Col>
      </Row>
      <Row>
        <Col xs="3" className="mb-2">
          <Input id="user-move-classname" placeholder="till klass (namn)" />
        </Col>
      </Row>
      <Row>
        <Col xs="3" className="mb-2">
          <Input
            id="user-move-customernumber"
            placeholder="till skola (fortnoxnummer)"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            color="primary"
            outline
            id="button-move-user"
            onClick={() => {
              var button = document.getElementById("button-move-user");
              button.disabled = true;

              var userEmail = document
                .getElementById("user-move-email")
                .value.trim();
              var className = document
                .getElementById("user-move-classname")
                .value.trim();
              var fortNoxNumber = document
                .getElementById("user-move-customernumber")
                .value.trim();

              axios
                .post(
                  `${API_BASE_URL}/User/Move?userEmail=${encodeURIComponent(
                    userEmail
                  )}&toSchoolFortNoxNumber=${fortNoxNumber}&toClassName=${className}`
                )
                .then((response) => {
                  if (response?.data?.result) {
                    toast.success(response.data.result, TOAST_CONFIG);
                  } else {
                    toast.warn("Svaret från servern var oväntat", TOAST_CONFIG);
                  }

                  button.disabled = false;
                })
                .catch((err) => {
                  var failMessage = err?.response?.data
                    ? err.response.data
                    : err;
                  toast.warn(failMessage, TOAST_CONFIG);

                  button.disabled = false;
                });
            }}
          >
            <FormattedMessage id="Move" />
          </Button>
        </Col>
      </Row>
    </div>
  );
}
